import Modal from "react-modal";
import { useState } from "react";
import Input from "../../../components/Input/Input";
import Select from "../../../components/Select/Select";
import { useEffect } from "react";
import { useUserStore } from "../../../contexts/userStore";
import BackupService from "../../../services/BackupService";
import { useAuth } from "../../../contexts/auth";
import Loader from "../../../components/Loader/Loader";
import Button from "../../../components/Button/Button";
import { LuCloudCog } from "react-icons/lu";
import "./ConfigBackup.css";
import { AxiosError } from "axios";
import ToggleButton from "../../../components/ToggleButton/ToggleButton";

const customStyles = {
	content: {
		top: "50%",
		left: "50%",
		right: "auto",
		bottom: "auto",
		marginRight: "-50%",
		transform: "translate(-50%, -50%)",
		backgroundColor: "var(--containerBackgroundColor)",
		border: "1px solid var(--borderColor)",
		borderRadius: '8px',
		boxShadow: 'var(--box-shadow)',
	},
};


export function ConfigBackup(props) {
	const { selectedCondominio, licences } = useUserStore();
	const { user } = useAuth();
	const [backupConfigId, setBackupConfigId] = useState(null);
	const [backupFrequency, setBackupFrequency] = useState("");
	const [backupHour, setBackupHour] = useState("");
	const [backupEnabled, setBackupEnabled] = useState(false);
	const [modalIsOpen, setModalIsOpen] = useState(props.modalIsOpen);
	const [unit, setUnit] = useState(null);
	const [backupConfigs, setBackupConfigs] = useState([]);
	const [showLoader, setShowLoader] = useState(false);
	const [error, setError] = useState(null);

	useEffect(() => {
		async function loadConfigs() {
			const response = await BackupService.listBackupConfigsByOrganization(user.userData.selectedOrganizationId);
			if (response instanceof AxiosError) {
				setError(error);
				return;
			}
			if (response.data) {
				setBackupConfigs(response.data);
			}
		}
		loadConfigs();
	}, [user]);

	useEffect(() => {
		setModalIsOpen(props.modalIsOpen);
	}, [props.modalIsOpen]);

	useEffect(() => {
		setUnit(selectedCondominio);
	}, [selectedCondominio])

	useEffect(() => {
		if (unit && licences && licences.length > 0 && backupConfigs && backupConfigs.length > 0) {
			const selectedUnitLicense = licences.find(license => license.id_condominium === Number(unit));
			if (!selectedUnitLicense) return;
			if (!Array.isArray(backupConfigs)) {
				return;
			}
			const config = backupConfigs.find(config =>
				config.organizationId === user.userData.selectedOrganizationId && Number(config.licenseId) === selectedUnitLicense.id
			);
			if (config) {
				setBackupConfigId(config.id);
				setBackupFrequency(config.frequency);
				setBackupHour(config.hour);
				setBackupEnabled(config.enabled);
			}
		}
	}, [
		unit,
		backupConfigs,
		licences,
		user.userData.selectedOrganizationId
	])

	function getUnitLicense() {
		return licences.find(license => license.id_condominium === Number(unit));
	}

	function buildPayload() {
		return {
			frequency: backupFrequency,
			hour: backupHour,
			enabled: backupEnabled,
		};
	}

	async function handleSubmitBackup(event) {
		event.preventDefault();
		const selectedUnitLicense = getUnitLicense();
		if (backupConfigId) {
			await BackupService.updateBackupConfig(
				backupConfigId,
				user.userData.selectedOrganizationId,
				selectedUnitLicense.id,
				buildPayload()
			);
		} else {
			await BackupService.createBackupConfig(
				buildPayload(),
				user.userData.selectedOrganizationId,
				selectedUnitLicense.id,
			);
		}
		handleCancel();
	}

	function handleCancel() {
		props.handleCancel(false);
	}

	return (
		<Modal
			isOpen={modalIsOpen}
			onRequestClose={handleCancel}
			style={customStyles}
			contentLabel="Modal"
			ariaHideApp={false}
		>
			<form onSubmit={handleSubmitBackup}>
				<div className="modal-content-container modal-config-backup">
					<h1 className="modal-text">
						<LuCloudCog />
						Configuração do backup do equipamento
					</h1>
					<div className="form-wrapper">
						<Select
							labelText="Licença"
							name="condominio"
							id="condominio"
							value={unit}
							onChange={({ target }) => setUnit(target.value)}
							options={props.optionsCondominios}
						/>
						<Select
							labelText="Frequência"
							name="frequency"
							id="frequency"
							value={backupFrequency}
							onChange={({ target }) => setBackupFrequency(target.value)}
							options={[
								{ value: "daily", text: "Diariamente" },
								{ value: "weekly", text: "Semanalmente" },
								{ value: "monthly", text: "Mensal" },
							]}
						/>
						<Input
							name="backup_hour"
							id="backup_hour"
							type="time"
							min="00:00"
							max="23:59"
							labelText="Hora"
							value={backupHour}
							onChange={({ target }) => setBackupHour(target.value)}
							required={false}
						/>
						<ToggleButton
							label="Ativo"
							name="enabled"
							id="enabled"
							defaultChecked={backupEnabled}
							onChange={({ target }) => {
								setBackupEnabled(target.checked);
							}}
							required={false}
							disabled={props.type === "consulta"}
						/>
					</div>
					<div className="modal-buttons-container">
						{showLoader ? (
							<Loader style={{ marginTop: '0px' }} />
						) : (
							<Button type="submit" label="Salvar"></Button>
						)}
					</div>
				</div>
			</form>
		</Modal>
	);
}